const timestatus = (state = [], action) => {
  switch (action.type) {
    case 'ADD_TIME':
    return {
        type: "ADD_TIME",
        timestatus: action.timestatus
      }
    default:
      return state
  }
}

export default timestatus